<template>
    <div >
      <div class="video">
        <video ref="video" playsinline autoplay></video>
        <canvas ref="canvas" width="100%" height="100%"></canvas>
        <div class="overlay overlay-top"></div>
        <div class="overlay overlay-bottom"></div>
        <div class="overlay overlay-left"></div>
        <div class="overlay overlay-right"></div>
      </div>
  
      <!-- <div class="video" style="z-index:23" v-if="selectedImage">
        <img :src="selectedImage"  style="width :100%;height :auto"/>
      </div>
      <button v-if="selectedImage" class="button-send" style="z-index:50 !important;background-color: red;color:white" @click="selectedImage = null">Close Image</button>
      <button v-if="selectedImage" class="button-save" style="z-index:50 !important;" @click="saveImage()">Save Image</button> -->
      
      <!-- <div class="fullscreen">
      </div> -->
  
      <!-- <button class="button-zoom-in" @click="zoomIn">+</button>
      <button class="button-zoom-out" @click="zoomOut">-</button> -->
  
      <!-- <div class="small-square" ref="smallSqaure"></div>
      <button class="button-capture" @click="captureImage">Capture Image</button>
      <button class="button-clear" @click="clearImage">Clear Image</button>
      <button class="button-send" @click="sendImage">Send Image</button>
      <div class="image-container" v-if="capturedImages.length >= 1">
        <div class="image-scroll">
          <div class="image-wrapper">
            <div v-for="(image, index) in capturedImages" :key="index" class="image-item" :style="{ backgroundImage: 'url(' + image + ')' }" @click="showImage(image)"></div>
          </div>
        </div>
      </div> -->
    </div>
  </template>
  
<script>
    import axios from 'axios'
    import * as tf from '@tensorflow/tfjs';
    // import { Storage } from '@google-cloud/storage'
    // const gprivate_key = require('./../sequre-351101-0bb01021d9bd.json')

    // const storage = new Storage({
    //     projectId: gprivate_key.project_id,
    //     keyFilename: gprivate_key.private_key
    // })

    
    // /*
    //     sequre-web-staging/tensorflowjssequre/object_sequre_20220909_lo_model-7572833559749066752_tf-js_2023-04-13T03_12_48.002337Z_dict.txt
    // */
    // const bucketName = 'sequre-web-staging'
    // const modelPath = 'tensorflowjssequre/object_sequre_20220909_lo_model-7572833559749066752_tf-js_2023-04-13T03_12_48.002337Z_model.json'

    // const bucket = storage.bucket(bucketName)
    // const file = bucket.file(modelPath)
    // const pathToFile = `https://storage.cloud.google.com/sequre-web-staging/tensorflowjssequre/object_sequre_20220909_lo_model-7572833559749066752_tf-js_2023-04-13T03_12_48.002337Z_model.json`

    // console.log(file.)
    // file.download()
    
    export default {
        data() {
            return {
                capturedImage: null,
                capturedImages: [],
                selectedImage : null,
                zoom : 1.7
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.startCamera();
            });
            this.loadModel()
            
            
        },
        methods: {
            drawDetectedObjects(predictions, canvas) {
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                predictions.forEach((prediction) => {
                    // Customize the drawing styles based on your preferences
                    ctx.strokeStyle = 'lime';
                    ctx.lineWidth = 2;
                    ctx.strokeRect(prediction.x, prediction.y, prediction.width, prediction.height);
                    ctx.font = '14px Arial';
                    ctx.fillStyle = 'lime';
                    ctx.fillText(prediction.label, prediction.x, prediction.y - 4);
                });
            },
            async detectObjects(model, image, inputSize) {
                // Preprocess the input image or video frame
                const inputTensor = this.preprocessInput(image, inputSize);

                // Perform object detection using the custom model
                const predictions = await model.executeAsync(inputTensor);
                // console.log(predictions)

                // Process the predictions to obtain the final detected objects
                // You need to customize this part based on the output format of your model
                const processedPredictions = this.processPredictions(predictions);

                // Dispose the input tensor to free memory
                inputTensor.dispose();

                return processedPredictions;
            },
            async detectInRealTime(model, video, canvas, inputSize) {
                setInterval (async () => {
                    tf.engine().startScope()
                    const predictions = await this.detectObjects(model, tf.browser.fromPixels(video), inputSize);
                    console.log(predictions)
                    this.drawDetectedObjects(predictions, canvas);
                    tf.engine().endScope()
                    await tf.nextFrame();
                }, 2500)
            },
            preprocessInput(input, inputSize) {
                const resizedImage = tf.image.resizeBilinear(input, [inputSize, inputSize]);
                const normalizedImage = resizedImage.div(255);
                const batchedImage = normalizedImage.expandDims(0);
                return batchedImage;
            },
            processPredictions(predictions, scoreThreshold = 0.5, iouThreshold = 0.5) {
                // Process the model's output according to your model's specifications
                // ...
                const classScores = predictions[0].arraySync()[0];
                const boxCoords = predictions[1].arraySync();
                // console.log(classScores , boxCoords)

                // Filter detections based on scoreThreshold
                const indices = [];
                const scores = [];
                for (let i = 0; i < classScores.length; i++) {
                    if (classScores[i][1] > scoreThreshold) {
                    indices.push(i);
                    scores.push(classScores[i][1]);
                    }
                }

                // Perform non-maximum suppression
                let selectedIndices = [];
                if (indices.length > 0) {
                    selectedIndices = tf.image.nonMaxSuppression(
                        tf.tensor2d(boxCoords.filter((_, i) => indices.includes(i)), [indices.length, 4]),
                        tf.tensor1d(scores),
                        100,
                        iouThreshold
                    ).arraySync();
                }


                // Get the final detection results
                const results = [];
                for (let index of selectedIndices) {
                    const [y1, x1, y2, x2] = boxCoords[indices[index]];
                    const score = scores[index];

                    results.push({
                    bbox: [x1, y1, x2 - x1, y2 - y1],
                    score: score,
                    class: 1 // Assuming you have only one class (QR code)
                    });
                }

                return results;
            },
            async loadModel() {
                // console.log(pathToFile)
                const modelUrl = '/tfjs/object_sequre_20220909_lo_model-7572833559749066752_tf-js_2023-04-13T03_12_48.002337Z_model.json'
                const model = await tf.loadGraphModel(modelUrl , {enableDebug : true});
                // const inputNodeName = model.inputs[0].name;
                console.log(model.inputs[0])

                // Get the input size
                // const inputSize = model.inputs[0].shape;

                // console.log('Input node name:', inputNodeName);
                // console.log('Input size:', inputSize);
                let inputSize = 256

            
                this.detectInRealTime(model, this.$refs.video, this.$refs.canvas, inputSize);
            },
            showLoading (title, subTitle) {
                this.$swal.showLoading();
            },
            closeLoading () {
                this.$swal.hideLoading();
            },
            triggerSuccess(message){
                this.$swal.fire({
                title: "Success!",
                icon: 'success',
                text: message ? message : "What Message?"
                })
            },
            triggerError(message){
                this.$swal.fire({
                title: "Error!",
                icon: 'error',
                html: message ? message : "What Message?"
                })
            },
            startCamera() {
                navigator.mediaDevices.getUserMedia({
                video: { facingMode:  "environment" },
                audio: false
                }).then(stream => {
                    this.$refs.video.srcObject = stream;
                    this.$refs.video.style['transform-origin'] = 'center center';
                    this.$refs.video.style['transform']='scale('+this.zoom+')';
                    this.$refs.video.play();
                }).catch(error => {
                console.log(error);
                });
            },
            stopVideo() {
                // this.$refs.video.pause();
                this.selectedImage = null;
            },
            showImage(image) {
                this.selectedImage = image;
                // this.$refs.video.pause();
            },
            clearImage () {
                this.$store.commit('clearCapturedImage')
                // this.capturedImages = this.$store.getters.capturedImage
                this.capturedImages = []
                // this.$set(this , 'capturedImages' , this.$store.getters.capturedImage)
            },
            async sendImage () {
                // alert('Image Send! API Not Available Yet')
        
                if (this.capturedImages.length == 0) {
                this.triggerError('No Image Captured');
                return;
                }
        
                //Sending last image
                this.showLoading("Sending Image");
                await axios.post('https://sweb-api.sequre.id/upload', {
                imageb64str : this.capturedImages[this.capturedImages.length - 1].slice(22, this.capturedImages[this.capturedImages.length - 1].length-1)
                }, {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json'
                }
                })
                .then((resp)=>{
                    this.triggerSuccess({title:`API Response: ${JSON.stringify(resp.data)}`});
                })
                .catch((err)=>{console.log(err)})
                .finally(()=>{
                    this.closeLoading();
                });
        
                //Clear Image afterwards
                this.clearImage();
            },
            captureImage() {
                const canvas = document.createElement('canvas');
                canvas.width = this.$refs.video.videoWidth * this.zoom;
                canvas.height = this.$refs.video.videoHeight * this.zoom;
                let ctx = canvas.getContext('2d');
        
                // Calculate the source dimensions to only capture the visible (zoomed) portion of the video
                const sourceWidth = this.$refs.video.videoWidth / this.zoom;
                const sourceHeight = this.$refs.video.videoHeight / this.zoom;
                const sourceX = (this.$refs.video.videoWidth - sourceWidth) / 2;
                const sourceY = (this.$refs.video.videoHeight - sourceHeight) / 2;
        
                // Draw the zoomed video frame on the canvas
                ctx.drawImage(this.$refs.video, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, canvas.width, canvas.height);
        
                // Convert the canvas content to a base64 encoded data URL and store it in a variable
                const capturedImage = canvas.toDataURL();
        
                // Commit the captured image to the Vuex store using the `setCapturedImage` mutation
                this.$store.commit('setCapturedImage', capturedImage);
        
                // Update the local `capturedImages` variable with the value from the Vuex store getter `capturedImage`
                this.capturedImages = this.$store.getters.capturedImage;
            },
            saveImage () {
                console.log(this.selectedImage)
                var a = document.createElement("a"); //Create <a>
                a.href = this.selectedImage; //Image Base64 Goes here
                a.download = "Image.png"; //File name Here
                a.click(); //Downloaded file
            }
        }
    }
</script>
  
<style scoped>
.image-container {
position: fixed;
bottom: 10px;
left: 10px;
right: 10px;
z-index: 22;
display: flex;
justify-content: center;
align-items: center;
background-color: rgba( 0,  0 , 0 ,0.3);
padding-top: 10px;
padding-bottom : 10px;
width : 100% !important;
overflow-x: scroll;
overflow-y: hidden;
}

.image-scroll {
max-height: 80px;

}

.image-wrapper {
display: flex;
justify-content: center;
align-items: center;
height: 100%;
width : 100%;
background-size: contain;
background-repeat: no-repeat;
background-position: center;
cursor: pointer;

}

.image-item {
width: 80px;
height: 80px;
margin-right: 10px;
border-radius: 5px;
/* background-size: cover; */
background-position: center;
}

.close-button {
position: absolute;
top: 10px;
right: 10px;
font-size: 20px;
cursor: pointer;
}

.video {
position: fixed;
top: 0;
right: 0;
bottom: 0;
left: 0;
width: 100%;
height: 100%;

}

canvas {
    position: fixed;
top: 0;
right: 0;
bottom: 0;
left: 0;
width: 100%;
height: 100%; 
}

/* video {

z-index : 0;
height: 100%;
width : 100%
} */

.overlay {
position: absolute;
background-color: rgba(0, 0, 0, 0.7);
pointer-events: none;
z-index: 1;
}
.overlay-top {
top: 0;
}

.overlay-bottom {
bottom: 0;
}

.overlay-top,
.overlay-bottom {
left: 0;
right: 0;
height: calc(50% - 100px);
}

.overlay-left,
.overlay-right {
top: calc(50% - 100px);
bottom: calc(50% - 100px);
width: calc(50% - 70px);
}

.overlay-left {
left: 0;
}

.overlay-right {
right: 0;
}

.small-square {
position: absolute;
top: 50%;
left: 50%;
width: 35%;
height: 50%;
max-width: 200px;
max-height: 200px;
transform: translate(-50%, -50%);
outline: 2px solid white;
z-index: 2;
}



video {
z-index: 0;
height: 100%;
width: 100%;
/* object-fit: cover; */
}

.button-capture {
position: fixed;
bottom: 7em; /* 20px / 16px = 1.25em */
right: 1.25em; /* 20px / 16px = 1.25em */
margin: 0.625em; /* 10px / 16px = 0.625em */
background-color: #fff;
border: 1px solid #000;
border-radius: 5px;
padding: 0.625em 1em; /* 10px / 16px = 0.625em, 16px = 1em */
font-size: 1em; /* 16px = 1em */
cursor: pointer;
z-index : 22;
}

.button-clear {
position: fixed;
bottom: 7em; /* 20px / 16px = 1.25em */
left: 1.25em; /* 20px / 16px = 1.25em */
margin: 0.625em; /* 10px / 16px = 0.625em */
background-color: #fff;
border: 1px solid #000;
border-radius: 5px;
padding: 0.625em 1em; /* 10px / 16px = 0.625em, 16px = 1em */
font-size: 1em; /* 16px = 1em */
cursor: pointer;
z-index : 22;
}

.button-send {
position: fixed;
top: 1em; /* 20px / 16px = 1.25em */
left: 1.25em; /* 20px / 16px = 1.25em */
margin: 0.625em; /* 10px / 16px = 0.625em */
background-color: #fff;
border: 1px solid #000;
border-radius: 5px;
padding: 0.625em 1em; /* 10px / 16px = 0.625em, 16px = 1em */
font-size: 1em; /* 16px = 1em */
cursor: pointer;
z-index : 22;
}

.button-save {
position: fixed;
top: 1em; /* 20px / 16px = 1.25em */
right: 1.25em; /* 20px / 16px = 1.25em */
margin: 0.625em; /* 10px / 16px = 0.625em */
background-color: green;
border: 1px solid #000;
border-radius: 5px;
color : white;
padding: 0.625em 1em; /* 10px / 16px = 0.625em, 16px = 1em */
font-size: 1em; /* 16px = 1em */
cursor: pointer;
z-index : 22;
}


.fullscreen {
position: fixed;
top : 0;
left : 0;
right : 0;
bottom : 0;
width: 100%;
height :100%;
background-color : rgba(0,0,0,0.4);
/* z-index : 20; */
}

.small-square {
position: absolute;
top : 50%;
left : 50%;
width: 35%;
height :50%;
max-width: 200px;
max-height: 200px;
background-color : transparent;
transform : translate(-50% , -50%);
border : 2px solid white;

z-index : 21;
}

.button-zoom-in {
position: fixed;
top: 1em;
right: 1.25em;
margin: 0.625em;
background-color: #fff;
border: 1px solid #000;
border-radius: 5px;
padding: 0.625em 1em;
font-size: 1em;
cursor: pointer;
z-index: 22;
width : 40px;
text-align: center;
}

.button-zoom-out {
position: fixed;
text-align: center;
top: 4.5em;
right: 1.25em;
margin: 0.625em;
background-color: #fff;
border: 1px solid #000;
border-radius: 5px;
padding: 0.625em 1em;
width : 40px;
font-size: 1em;
cursor: pointer;
z-index: 22;
}

</style>
  